import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './AddButton.less'

interface AddButtonProps {
  onAdd: () => void
  tooltipText?: string
  className?: string
}

export const AddButton: React.FC<AddButtonProps> = ({
  onAdd,
  tooltipText = 'Add',
  className = ''
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onAdd()
  }

  return (
    <div className={`add-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="add-button"
        onMouseDown={handleClick}
        aria-label="Add"
        title={tooltipText}
      >
        <Icon
          name={IconName.Add}
          className="add-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
